module.exports = __webpack_public_path__ + "assets/img/SVIP.dfb99db0.svg";